import { Link, Text } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export interface TikTokLegalTextProps {
  brandedContentSelected: boolean;
}

const TikTokLegalText: React.FC<TikTokLegalTextProps> = ({
  brandedContentSelected,
}) => {
  return (
    <Text variant="legal" className={block('legal-text')}>
      By posting, you agree to TikTok's
      {brandedContentSelected ? (
        <>
          {' '}
          <Link
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/bc-policy/en"
          >
            Branded Content Policy
          </Link>{' '}
          and{' '}
        </>
      ) : (
        ' '
      )}
      <Link
        target="_blank"
        href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
      >
        Music Usage Confirmation
      </Link>
    </Text>
  );
};

export default TikTokLegalText;
